<template>
  <b-modal
    id="modal-11"
    title="اطلاعات تراکنش"
    :hide-header-close="true"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    hide-footer
    v-model="showInfo"
    @customChange="closePopup"
  >
    <div
      class="row"
      v-if="transaction != null && transaction.transaction_id != null"
    >
      <div style="color: red" class="col-md-6">
        <b-form-group label="مبلغ بازگشت وجه (ریال):">
          <div style="color: red" class="form-control">
            {{ transaction.refund_cost.toLocaleString() }} ریال
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6" style="color: red">
        <b-form-group label="کد رهگیری برگشت وجه:">
          <div class="form-control" style="color: red">
            {{ transaction.refund_tracknumber }}
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="وضیعت تراکنش:">
          <div class="form-control">پرداخت شده</div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="کد تراکنش:">
          <div class="form-control">
            {{ transaction.transaction_id }}
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="مبلغ تراکنش (ریال):">
          <div class="form-control">
            {{ transaction.cost.toLocaleString() }} ریال
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="آدرس درخواست دهنده:">
          <b-input-group>
            <template #append>
              <b-input-group-text
                ><strong class="text-danger"
                  ><b-img
                    v-if="transaction.ip"
                    class="float-left pt-0"
                    :src="'media/svg/flags/Question-circle.svg'"
                    width="30"
                    height="20"
                  ></b-img></strong
              ></b-input-group-text>
            </template>
            <div class="form-control">
              {{ transaction.ip }}
            </div>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="کد رهگیری پرداخت:">
          <div class="form-control">
            {{ transaction.sale_reference_id }}
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="شماره کارت:">
          <div class="form-control" dir="ltr">
            {{ transaction.card_holder_pan }}
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="شماره فاکتور:">
          <div class="form-control" dir="ltr">
            {{ transaction.orderid }}
          </div>
        </b-form-group>
      </div>
    </div>
    <div v-else-if="transaction != null && transaction.transaction_id == null">
      <b-form-group label="توضیحات:">
        <div>
          اکانت برگشت وجه در تاریخ
          {{ transaction.created_at | moment("jYYYY-jM-jD [,] HH:mm:ss") }} به
          مبلغ {{ transaction.bes.toLocaleString() }} ریال با موفقیت شارژ گردید.
        </div>
      </b-form-group>
    </div>
    
    <div class="float-right">
      <b-button variant="primary" @click="closePopup">بستن</b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "transactionInfo",
  props: ["transaction", "showInfo"],
  methods: {
    closePopup() {
      this.$emit("customChange", false);
    },
  },
};
</script>
 
<style>
</style>